import { render, staticRenderFns } from "./LanguageCourse.vue?vue&type=template&id=5ba45e88&scoped=true"
import script from "./LanguageCourse.vue?vue&type=script&lang=js"
export * from "./LanguageCourse.vue?vue&type=script&lang=js"
import style0 from "./LanguageCourse.vue?vue&type=style&index=0&id=5ba45e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba45e88",
  null
  
)

export default component.exports